// API base URL resolved from the host the app is served on, so one build talks to
// the right backend per environment (no manual edits before each deploy).
//   QA hosts + localhost  -> QA API
//   prd hosts + anything else -> PROD API
const API_URLS = {
  qa: "https://ahcrecruitment-qa-api.azurewebsites.net/api/",
  prod: "https://ahcrecruitment-api-bsakdgc2bjarghdp.uaenorth-01.azurewebsites.net/api/",
  // local: "http://localhost:5080/api/",
};

// Hosts that should hit the QA API. Keep in sync with the QA hosts used for the
// redirect URI (msalConfig.js) and the table-driven approval flag (RequestDetails.js).
const QA_HOSTS = [
  "shamlrecruit-qa.awjholding.com",
  "ahcrecruitment-qa.azurewebsites.net",
  "localhost",
];

const resolveApiUrl = () => {
  if (typeof window === "undefined") return API_URLS.prod;
  return QA_HOSTS.includes(window.location.hostname) ? API_URLS.qa : API_URLS.prod;
};

export const API_URL = resolveApiUrl();
